import { Badge, Box, HStack, Text, Tooltip } from '@chakra-ui/react';
import { X } from 'lucide-react';

import { iconSize } from '@duke-hq/ui/constants/scalable';

export function RequirementChip({
  colourScheme,
  label,
  description,
  removeLabel,
  onRemove,
  'data-testid': testId,
}: {
  colourScheme: string;
  label: string;
  description: string;
  removeLabel: string;
  onRemove: () => void;
  'data-testid': string;
}) {
  return (
    <Badge colorScheme={colourScheme} fontFamily="mono" fontSize="xs" data-testid={testId}>
      <Tooltip label={description}>
        <HStack spacing={1}>
          <Text>{label}</Text>
          <Box as="button" type="button" aria-label={removeLabel} onClick={onRemove}>
            <X size={iconSize.xs} />
          </Box>
        </HStack>
      </Tooltip>
    </Badge>
  );
}
